import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UtilityService } from './shared/utility.service';
import { delayedRetryHttp } from './shared/delayedRetry';
import { SimpleResponse } from '../../models/contact-modal/genericResponse.model';
import { EngageMetricListResponse } from '../../models/contact-modal/engage-metric.model';

@Injectable({
  providedIn: 'root'
})
export class EngageMetricService {

    private baseUrl: string;
    private api: string = "api/Engage/EngageMetric";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }


    async engageMetric_CountByContactID(encryptedUser: string,  clpCompanyId : number,  clpuserId : number,  contactID : number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/EngageMetric_CountByContactID/${clpCompanyId}/${clpuserId}/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "clpuserId - " + clpuserId + "," + "contactID - " + contactID, encryptedUser, "EngageMetricService", "countByContact"); });
        return a;
    }

    async engageMetric_LoadByContactID(encryptedUser: string, clpCompanyId: number, clpuserId: number, contactID: number): Promise<EngageMetricListResponse | void> {
        const a = await this.httpClient
            .get<EngageMetricListResponse>(`${this.baseUrl}/EngageMetric_LoadByContactID/${clpCompanyId}/${clpuserId}/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "clpuserId - " + clpuserId + "," + "contactID - " + contactID, encryptedUser, "EngageMetricService", "engageMetric_LoadByContactID"); });
        return a;
    }

    async engageMetric_UpdateValue(encryptedUser: string, clpCompanyId: number, clpuserId: number, engageMetricID : number, strValue : string = ''): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/EngageMetric_UpdateValue/${clpCompanyId}/${clpuserId}/${engageMetricID}/${strValue}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "clpuserId - " + clpuserId + "," + "engageMetricID - " + engageMetricID + "," + "strValue - " + strValue, encryptedUser, "EngageMetricService", "engageMetric_UpdateValue"); });
        return a;
    }

    async engageMetric_Delete(encryptedUser: string, clpCompanyId: number, clpuserId: number, engageMetricID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/EngageMetric_Delete/${clpCompanyId}/${clpuserId}/${engageMetricID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "clpuserId - " + clpuserId + "," + "engageMetricID - " + engageMetricID, encryptedUser, "EngageMetricService", "engageMetric_Delete"); });
        return a;
    }
    async LoadMetricValuesbyNameCompanyID(encryptedUser: string, clpCompanyId: number, metricName: string): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/LoadMetricValuesbyNameCompanyID/${clpCompanyId}?metricName=${metricName}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "metricName - " + metricName, encryptedUser, "EngageMetricService", "LoadMetricValuesbyNameCompanyID"); });
        return a;
    }

    async loadMetricNamesbyCompanyID(encryptedUser: string, clpCompanyId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/LoadMetricNamesbyCompanyID/${clpCompanyId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyID - " + clpCompanyId, encryptedUser, "EngageMetricService", "loadMetricNamesbyCompanyID"); });
        return a;
    }
}
